import PaddedSection from '../../atoms/PaddedSection';
import React, { Component } from 'react';
import brochure from '../../../assets/images/taggis-brochure.jpg';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String} fileName
 * @prop {String} heading
 *
 * @augments {Component<Props>}
 */

export default class LearnMore extends Component {

	render () {
		const { buttonLabel, fileName, heading } = this.props;

		const href = require(`../../../assets/files/${fileName}`);

		const arrowDown = require(`../../../assets/svg/icon-arrow-down.svg`);

		return (
			<PaddedSection>
				<div className='LearnMore'>
					<div className='LearnMore__brochure'>
						<picture>
							<img
								src={brochure}
								alt='brochure'
								className='LearnMore__image'
							/>
						</picture>
					</div>
					<div className='LearnMore__content'>
						<div>
							<h1>{heading}</h1>
							<div>
								<a
									className='Button Button-link'
									href={href}
									rel='noopener noreferrer'
									target='_blank'
								>
									<img src={arrowDown} alt='Arrow Down' />
									<span>{buttonLabel}</span>
								</a>
							</div>
						</div>

					</div>
				</div>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/LearnMore/LearnMore.js